import { type FC, useEffect } from 'react';
import { sendAnalyticsData } from '@mwl/core-lib';
import ArrowIcon from '@public/assets/common/icons/arrowDown.svg';
import SearchIcon from '@public/assets/common/icons/search.svg';
import { getAnalyticsClickData, getAutocompleteOpenAnalytics } from './SportSearchAutocomplete.analytics';
import type { SportSearchAutocompleteProps } from './SportSearchAutocomplete.types';
import styles from './SportSearchAutocomplete.module.scss';
export const SportSearchAutocomplete: FC<SportSearchAutocompleteProps> = ({
  searchResult,
  handleSearchClick,
  activeElement
}) => {
  const autocompleteOpenAnalytics = getAutocompleteOpenAnalytics(cn(styles.root, {
    [styles.withResult]: searchResult
  }));
  const handleClickAutocomplete = (value: string, cls: string) => {
    handleSearchClick(value);
    const analytics = getAnalyticsClickData(cls, value);
    sendAnalyticsData(analytics.click.eventName, analytics.click.data);
  };
  useEffect(() => {
    sendAnalyticsData(autocompleteOpenAnalytics.open.eventName, autocompleteOpenAnalytics.open.data);
  }, [autocompleteOpenAnalytics]);
  if (!searchResult.length) {
    return null;
  }
  return <div className={cn(styles.root, {
    [styles.withResult]: searchResult
  })} data-sentry-component="SportSearchAutocomplete" data-sentry-source-file="SportSearchAutocomplete.tsx">
      {searchResult?.map(({
      type,
      value
    }, index) => <button type="button" onClick={() => handleClickAutocomplete(value, styles.searchResult)} key={value + type} className={cn(styles.searchResult, {
      [styles.active]: activeElement === index
    })}>
          <div className={styles.searchIcon}>
            <SearchIcon width={16} height={16} />
          </div>
          <p className={styles.text}>{value}</p>
          <div className={styles.arrowIcon}>
            <ArrowIcon />
          </div>
        </button>)}
    </div>;
};